module.exports = __webpack_public_path__ + "img/otros_servicios.88a5f2f0.webp";